import { SESSION_BLOCKING_REASONS, SESSION_PHASES } from "./constants";

export const resolveSessionAccessState = ({
  sessionState = {},
} = {}) => {
  const phase = sessionState?.phase || null;
  const recoveryActive = phase === SESSION_PHASES.recoveryRequired;
  const isBlocked = recoveryActive;

  const blockingReason = recoveryActive
    ? sessionState?.blockingReason || SESSION_BLOCKING_REASONS.unknown
    : null;

  const targetPath =
    typeof sessionState?.targetPath === "string" && sessionState.targetPath.trim()
      ? sessionState.targetPath
      : null;

  const recoveryContext =
    typeof sessionState?.recoveryContext === "string" && sessionState.recoveryContext.trim()
      ? sessionState.recoveryContext.trim()
      : null;

  return {
    isBlocked,
    blockingReason,
    targetPath,
    recoveryContext,
    phase,
  };
};

export const isSessionAccessBlocked = (input) =>
  resolveSessionAccessState(input).isBlocked;
